import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useDebug } from '../utils/hooks/useDebug.js';
import { mergeMediaQueries, debugCss, calcContainerSize, calcContainerPadding } from '../utils/styleHelpers.js';

const Container = forwardRef(({
  as,
  children,
  className,
  hasNoPadding = false,
  isFluid = false,
  maxWidth,
  testId,
  ...handler
}, ref) => {
  const classNames = [className, useDebug()];
  return React.createElement(ContainerElement, _extends({
    ref: ref,
    $hasNoPadding: hasNoPadding,
    $isFluid: isFluid,
    $maxWidth: maxWidth,
    as: as,
    className: classNames.join(' '),
    "data-cy": testId
  }, handler), children);
});
Container.displayName = 'Container';
var Container$1 = Container;
const ContainerElement = styled.div.withConfig({
  displayName: "Container__ContainerElement",
  componentId: "sc-1385zdx-0"
})(["box-sizing:border-box;margin-left:auto;margin-right:auto;max-width:100%;width:100%;", " ", ""], mergeMediaQueries(calcContainerPadding, calcContainerSize), debugCss('container'));

export { Container$1 as default };
//# sourceMappingURL=Container.js.map
